module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/affiliate/global/member/images/StatsRemote.png", __webpack_public_path__ + "_/_/global/member/images/StatsRemote.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/affiliate/global/member/images/StatsRemote.png
// module id = 77
// module chunks = 5